// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"AvatarCell_Avatar__2-cWa","HidingColorIcon":"AvatarCell_HidingColorIcon__1WhjN"};